export default {"src":"/_next/static/media/arrow-forward-citrine.7b7ca5bf.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};